/* eslint-disable jsx-a11y/anchor-is-valid */
import openseaIcon from "assets/images/opensea.svg";

const Community: React.FC = () => {
  return (
    <section className="community padding-top padding-bottom">
      <div className="container">
        <div className="comminity__wrapper">
          <div className="section-header text-center">
            <p className="subtitle">Our Community</p>
            <h2>Join Our Cumminity and get early access</h2>
          </div>
          <div className="btn-group justify-content-center">
           
            <a href="https://opensea.io/collection/egyption-punks" className="default-btn">
              <span>
                <img
                  src={openseaIcon}
                  alt="opensea icon"
                  width="20"
                  height="20"
                />
                Join Opensea
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;
